/// <reference types="fhir" />

import { Actions, Effect } from "@ngrx/effects"; // Effect, Actions, toPayload
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { empty } from "rxjs/observable/empty";
import "rxjs/add/operator/do";
import { Action } from "@ngrx/store";
import * as UserActions from "../actions/user.actions";
import { AuthService } from "../../services/auth.service";
import { App } from "ionic-angular";
import { FrontPage } from "../../../pages/front.page/front.page";
import { tap } from "rxjs/operators/tap";
import { DashboardService } from "../../services/dashboard.service";
import { SupportActionsService } from "../../services/support-actions.service";
import { ManualItemsService } from "../../services/manual-items.service";

@Injectable()
export class UserEffects {
  constructor(
    private action$: Actions,
    private auth: AuthService,
    private dashboard: DashboardService,
    private supportActions: SupportActionsService,
    private manual: ManualItemsService,
    private app: App
  ) {}

  @Effect({ dispatch: false })
  setJwt$: Observable<Action> = this.action$
    .ofType<UserActions.SetJWTAction>(UserActions.SET_JWT)
    .do(action => {
      this.auth.setUserProfile(action.payload.jwt);
      return empty();
    });

  @Effect({ dispatch: false })
  login$: Observable<Action> = this.action$
    .ofType<UserActions.LoginAction>(UserActions.LOGIN)
    .do(action => {
      console.log("EFFECT ACTION", action);
      this.dashboard.getDefinitions().subscribe(result => {
        this.dashboard.store.dispatch(
          new UserActions.UpdateAction({
            definitionsLoaded: true
          })
        );
        setTimeout(() => {
          this.supportActions.getSupportActions();
          this.manual.getManualItems();
        }, 10000);
      });
      return empty();
    });

  @Effect({ dispatch: false })
  logout$: Observable<Action> = this.action$
    .ofType<UserActions.LogoutAction>(UserActions.LOGOUT)
    .pipe(
      tap(action => {
        const rootNav = this.app.getRootNav();
        rootNav.setRoot(FrontPage);
        rootNav.popToRoot();
        return empty();
      })
    );
}



// WEBPACK FOOTER //
// ./src/app/store/effects/user.effects.ts